import * as PIXI from "pixi.js"
import Painter from "./pixi/paint/Painter";
import EventApi from "../../../../api/EventsApi";

const FRAME = .9, MARGIN = (1 - FRAME) / 2;
export interface ICardInfo {
    cardId: number;
    pileId: number;
    actions: Array<any>;
    bgSrc: string;
    cardSize: { width: number, height: number };
}

export default class PixiPainter {

    private readonly app: PIXI.Application;
    public painter: Painter | null = null;
    public static readonly margin = { x: MARGIN * window.innerWidth, y: MARGIN * window.innerHeight };
    private readonly oldWidth:  number;
    private readonly oldHeight: number;

    /**
     * Получение инстанса PixiPainter
     */
    private static self: PixiPainter | undefined;
    public static getInstance(img: HTMLImageElement): PixiPainter
    {
        if (! PixiPainter.self) {
            PixiPainter.self = new PixiPainter(img);
        }
        return PixiPainter.self;
    }

    private constructor(img: HTMLImageElement)
    {
        this.oldWidth  = window.innerWidth;
        this.oldHeight = window.innerHeight;
        this.app = new PIXI.Application({
            antialias: true,
            width:  FRAME * window.innerWidth,
            height: FRAME * window.innerHeight,
            backgroundAlpha: 0,
            resolution: window.devicePixelRatio || 1,
        });

        this.app.view.style.display = "block";
        this.app.view.style.width  = Math.floor(FRAME * window.innerWidth)  + 'px';
        this.app.view.style.height = Math.floor(FRAME * window.innerHeight) + 'px';
        this.app.view.style.position = "absolute";
        this.app.view.style.left = PixiPainter.margin.x + 'px';
        this.app.view.style.top  = PixiPainter.margin.y + 'px';

        this.painter = new Painter(this.app.renderer, img);
        this.painter.visible = false;
        this.app.stage.addChild(this.painter);

        const handler = () => {
            const SmallWindowSize = (window.innerWidth < 1200);
            EventApi.triggerEvent(EventApi.EDIT_SMALL_SIZE, {isSmallWindowSize: SmallWindowSize});
            this.app.view.style.visibility = SmallWindowSize ? "hidden" : "visible";
            if (!SmallWindowSize) {
                const kResize = Math.min(window.innerWidth / this.oldWidth, window.innerHeight / this.oldHeight);
                this.app.view.style.width  = Math.floor(FRAME * kResize * this.oldWidth)  + 'px';
                this.app.view.style.height = Math.floor(FRAME * kResize * this.oldHeight) + 'px';
            }
        }
        window.addEventListener('resize', handler, false);

        EventApi.addEventListener(EventApi.EDIT_MODE_KEY, (e: any) => {
            if (this.painter) {
                this.painter.editModeOn();
                this.painter.visible = true;
            }
        });

        document.addEventListener('keyup', (e: KeyboardEvent) => {
            e.preventDefault();
            this.painter?.onKeyup(e);
        });

        this.app.ticker.add((delta) => {
            this.painter?.update(delta);
        });

    }

    /**
     * Получение вида для вставки в ДОМ
     */
    public get view(): HTMLCanvasElement {
        return this.app.view;
    }

    /**
     * Получение модуля рисования
     */
    public get paint() {
        return this.painter;
    }

}
